import { Injectable } from '@angular/core';
import { FileDetails } from '../models/file-details.model';
import { Dictionary } from '../models/dictionary';
export class GlobalsService {
public XMLList: Dictionary<FileDetails> = new Dictionary<FileDetails>();

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GlobalsService_tsickle_Closure_declarations() {
/** @type {?} */
GlobalsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GlobalsService.ctorParameters;
/** @type {?} */
GlobalsService.prototype.XMLList;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
